<ng-template #tabsListTpl>
    <ul class="tabsList" [class._verticalMode]="verticalMode">
        <li class="tabsList-item" *ngFor="let tab of tabs"
            [ngClass]="{_isSelected : tab.selected === true, _hasAlert: tab.withAlert === true }">
            <button type="button" class="tabsList-item-link grid-x align-middle" (click)="selectTab(tab)" [disabled]="tab.disabled">
                <div class="cell auto">
                    {{tab.tabText}}
                </div>
                <div class="cell shrink tabsList-item-link-alert" *ngIf="tab.withAlert">
                    <a-badge [visibility]="'ERROR'" [size]="'SMALL'">x</a-badge>
                </div>
            </button>
        </li>
    </ul>
</ng-template>

<div class="tabsListRow" *ngIf="!verticalMode; else plainTabsList">
    <ng-container [ngTemplateOutlet]="tabsListTpl"></ng-container>
    <div class="tabsListRow-actions">
        <ng-content select="[tabsHeaderActions]"></ng-content>
    </div>
</div>
<ng-template #plainTabsList>
    <ng-container [ngTemplateOutlet]="tabsListTpl"></ng-container>
</ng-template>

<div class="tab-container" [class._verticalMode]="verticalMode">
    <ng-content></ng-content>
</div>
